exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".no-match {\n  width: 100%;\n  min-height: 760px;\n}\n.no-match .container {\n  padding: 200px 0 100px;\n  margin: 0 auto;\n  width: 620px;\n  height: 300px;\n  text-align: center;\n}\n.no-match .title {\n  font-size: 80px;\n  color: #666;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n.no-match .desc {\n  font-size: 26px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/nomatch/index.less
// module id = 1518
// module chunks = 0